import { camelToSnakeCase, snakeToCamelCase } from 'utils/recursiveChangeCase';

const addPayloadCasingInterceptors = client => {
  client.interceptors.request.use(request => {
    const payloadType = request.data && request.data.constructor.name;
    if (request.data && (payloadType === 'Object' || payloadType === 'Array')) {
      request.rawData = request.data;
      request.data = camelToSnakeCase(request.data); // eslint-disable-line no-param-reassign
    }

    if (request.params) {
      request.rawParams = request.params;
      request.params = camelToSnakeCase(request.params); // eslint-disable-line no-param-reassign
    }

    return request;
  });

  client.interceptors.response.use(
    response => {
      if (response.data) {
        response.rawData = response.data;
        response.data = snakeToCamelCase(response.data); // eslint-disable-line no-param-reassign
      }
      return response;
    },
    error => {
      if (error?.response?.data) {
        error.response.rawData = error.response.data; // eslint-disable-line no-param-reassign
        error.response.data = snakeToCamelCase(error.response.data); // eslint-disable-line no-param-reassign
      }
      return Promise.reject(error);
    },
  );

  return client;
};

export default addPayloadCasingInterceptors;
